import http from "../../../core/utils/apis/api";

const getEventDetailsData = async (id) => {
    try {
        const response = await http({
            method: 'GET',
            url: `/events/${id}`,

        });

        return response;
    } catch (e) {
        throw e;
    }

}

const subscribeToEvent = async (subscriptionData) => {
    try {
      const response = await http({
        method: "POST",
        url: `/event-requests/subscribe`,
        data: subscriptionData,
      });
      return response;
    } catch (e) {
      throw e;
    }
  };
  
  const unSubscribeToEvent= async (id) => {
    try {
        const response = await http({
            method: 'DELETE',
            url: `/event-requests/unsubscribe/${id}`
        });
        return response;
    } catch (e) {
        throw e;
    }
  }

const eventDetailService = {
    getEventDetailsData,
    subscribeToEvent,
    unSubscribeToEvent,
};

export default eventDetailService;